@if (pagelet().stringParam('Title')) {
<h2 class="text-center">{{ pagelet().stringParam('Title') }}</h2>
} @if (listStyle === 'carousel') { @if (categoryIDs$ | async; as categoryIDs) {
<swiper [config]="swiperConfig">
  @for (categoryID of categoryIDs; track categoryID) {
  <ng-template swiperSlide>
    <custom-category-tile [categoryUniqueId]="categoryID" />
  </ng-template>
  }
</swiper>
} } @else {
<div class="product-list row" [ngClass]="CSSclass">
  @if (categoryIDs$ | async; as categoryIDs) { @for (categoryID of categoryIDs; track categoryID) {
  <div [ngClass]="listItemCSSClass">
    <custom-category-tile [categoryUniqueId]="categoryID" />
  </div>
  } }
</div>
}
